import React from "react";

function SectionHeadingBadge(props: any) {
  const { text } = props;
  return (
    <div>
      <button className="bg-transparent border border-1 border-secondary rounded-pill  py-2 px-2 poppins-medium text-transform-uppercase font-13 letter-spacing-2 color-primary w-auto">
        {text}
      </button>
    </div>
  );
}

export default SectionHeadingBadge;
